import React from "react";
import { Container, Form, Button, Message } from "semantic-ui-react";
import moment from "moment";
import DatePicker from "react-datepicker";
import { renewalService } from "../../services/renewal.service";
import { IAgent } from "../../models/agent.interface";
import { IStoreState } from "../../redux/reducers/root.reducer";
import { connect } from "react-redux";

import axios from 'axios';
import {NavigateFunction} from "react-router-dom";

interface IProps {
  agent: IAgent | null;
  navigate:NavigateFunction; 
}
interface IState {
  renewalDate: Date;
  paymentRef: string | null;
  showRenewalDateSavedMessage: boolean;
  showRenewalDateSaveErrorMessage: boolean;
  failed: boolean;
  email: string | null;
  paymentOk: boolean | null;
  pol_ref: string|null;
  ready:boolean;
}

export class _Thankyou extends React.Component<IProps, IState> {
  state: IState = {
    renewalDate: new Date(),
    paymentRef: null,
    showRenewalDateSavedMessage: false,
    showRenewalDateSaveErrorMessage: false,
    failed: false,
    email: null,
    paymentOk: null, 
    pol_ref:null, 
    ready:false
  };

  componentDidMount() {

      const l = window.location;
      //console.log("ref:" + (new URLSearchParams(l.search).get("ref")));
      this.setState({
          paymentRef: new URLSearchParams(l.search).get("ref"),
          failed: new URLSearchParams(l.search).get("failed") === 'true',
      },()=>{
        axios.get(`/status/${this.state.paymentRef}`, {headers:{'Content-type':"application/json", Accept: "application/json"}})
          .then(resp => this.setState({
            email:resp.data.email,
            paymentOk: resp.data.paymentSuccess,
            pol_ref:resp.data.pol_ref,
            ready:true   
          },()=>{
             // console.log("pol_ref:"+this.state.pol_ref);
          }))
      });
  }

  render() {
    if (this.state.ready) {
        if (this.state.paymentRef == null) {
            return <Container>
                <div><h2>No payment reference</h2></div>
            </Container>
        }
        if (this.state.failed || this.state.paymentOk === false) {
            return <Container>
                <div>
                    <h2>Unfortunately we haven't been able to take a payment for your
                        Landlord Extras.</h2>
                    <p>
                        The card details you have supplied can’t be processed by our card payment
                        partner, but we have set up your policy on our systems and can take
                        payment over the phone to make sure you are still covered. You can call us
                        on {(this.props.agent && this.props.agent.telephone) || "01603 216399"} during office hours but
                        we’ll also try to call you on the
                        phone number you supplied - you’ll know its us as we always call from an
                        01603 number.
                    </p>
                    <p>
                        If you have any other questions or concerns the please call us or email us at
                        landlords@alanboswell.com.
                    </p>
                </div>
            </Container>
        }
        if (this.state.email === null) {
            return null;
        }
        return (
            <>
                <Container>
                    <div>
                        <h2>Payment successful</h2>
                        <p>
                            Your purchase of Landlord Extras is confirmed and we will email your policy documents
                            to: {this.state.email}
                        </p>
                        <p>
                            If you have any questions or concerns, please contact our Landlords &amp; Tenants Insurance
                            team on {(this.props.agent && this.props.agent.telephone) || "01603 216399"} who will be happy
                            to help
                            you. Please quote your policy reference when you contact us.
                        </p>
                    </div>
                    <br/>
                    <div className="b2c__card">
                        <h2>Price Beater Guarantee</h2>
                        <p>
                            If you have Landlord’s Buildings and Contents insurance from another provider, tell us when
                            it’s due for renewal and we will contact you nearer the
                            time and guarantee to beat your quote*
                        </p>
                        <p>My renewal date is around:</p>
                        <div>
                            <Form className="halfWidth">
                                <Form.Field>
                                    <DatePicker
                                        autoComplete="off"
                                        dateFormat="dd/MM/yyyy"
                                        minDate={moment().toDate()}
                                        onChange={(date: any) => {
                                            this.setState({renewalDate: date});
                                        }}
                                        placeholderText="Start date (DD/MM/YYYY)"
                                        selected={this.state.renewalDate}
                                    />
                                </Form.Field>
                            </Form>
                            <br/>
                            <Button
                                className=""
                                size="large"
                                positive
                                onClick={(event: any) => {
                                    event.preventDefault();
                                    if (this.state.paymentRef) {
                                        renewalService
                                            .saveRenewalDate(
                                                this.state.paymentRef,
                                                this.state.renewalDate
                                            )
                                            .then(res => {
                                                if ((res.status = 202)) {
                                                    this.setState({
                                                        showRenewalDateSavedMessage: true,
                                                        showRenewalDateSaveErrorMessage: false
                                                    });
                                                } else {
                                                    this.setState({
                                                        showRenewalDateSavedMessage: false,
                                                        showRenewalDateSaveErrorMessage: true
                                                    });
                                                }
                                            })
                                            .catch(res => {
                                                this.setState({
                                                    showRenewalDateSavedMessage: false,
                                                    showRenewalDateSaveErrorMessage: true
                                                });
                                            });
                                    }
                                }}
                            >
                                Save
                            </Button>
                        </div>
                        <br/>
                        <div hidden={!this.state.showRenewalDateSavedMessage}>
                            <Message success>Renewal date updated</Message>
                        </div>
                        <div hidden={!this.state.showRenewalDateSaveErrorMessage}>
                            <Message negative>
                                Error occurred while updating the Renewal Date
                            </Message>
                        </div>
                        <br/>
                        <div>
                            <p>
                                <strong>
                                    Our landlord products are five-star rated and automatically include:
                                </strong>
                            </p>
                            <ul>
                                <li>Malicious damage by tenant (including cannabis farms);</li>
                                <li>Accidental damage cover;</li>
                                <li>Cover while a property is unoccupied for up to 90 days;</li>
                                <li>The cost of rehousing your tenant following damage;</li>
                                <li>Reimbursement for loss of rent following damage.</li>
                            </ul>
                            <p>
                                Not only that, we will refund up to &pound;50.00 per property from this purchase if you
                                also purchase Landlord’s Buildings and Contents insurance from us some
                                time in the next 30 days.
                            </p>
                            <p>*Subject to Terms and Conditions</p>
                        </div>
                    </div>
                </Container>
            </>
        );
    }
    else {
        return (<></>);
    }
  }
}

const mapStateToProps = ({
  agent,
}: IStoreState): {
  agent: IAgent | null;
} => {
  return {
    agent
  };
};

export const Thankyou = connect(mapStateToProps)(_Thankyou);
